export const formatPhoneNumber = (phone: string | null | undefined): string => {
  if (phone === null || phone === undefined) {
    return '';
  }
  return phone.replace(/\D/g, '');
};
